import React, { useEffect, useState } from 'react';
import { EmployeeEvent } from 'src/interfaces/api/Gaming';
import useGamingFeed from 'src/hooks/api/useGamingFeed';

const useEmployeeEvents = (employeeId?: string) => {
  const { getEmployeeEvents } = useGamingFeed();

  const [events, setEvents] = useState<EmployeeEvent[]>([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page] = useState(1);
  const [limit] = useState(40);
  const [refreshCount, setRefreshCount] = useState(0);

  useEffect(() => {
    if (employeeId) {
      setLoading(true);
      getEmployeeEvents(employeeId, page, limit)
        .then((events) => {
          setEvents(events.items);
          setTotal(events.total);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [employeeId, refreshCount]);

  const refresh = () => setRefreshCount((count) => 1 + count);

  return { loading, events, refresh, total };
};

export default useEmployeeEvents;
